import { get } from 'lodash-es';
import { useContext, useState } from 'react';

import { ExplorerContext } from '@page/explorer/explorer.provider';
import { ExplorerSelect } from '@page/explorer/explorer.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Card } from '@atom/card/card';
import { Input } from '@atom/form/input/input';
import { Title } from '@atom/typography/typography';
import { Form } from '@form/common.style';

import { FormItemWrapper, TitleWrapper } from './explorer-vars-header.style';

const filteredVars = ['dev_auth_host', 'prod_auth_host', 'apiKey', 'consumerId'];

export const ExplorerVarsHeader = () => {
  const { setVariables, variables, consumers, credentials } = useContext(ExplorerContext);
  const handleSetVariables = (key: string) => (value: any) => setVariables({ [key]: value.target.value });
  const handleSearchVariables = (key: string) => (value: string) => setVariables({ [key]: value });
  const [isShowedMore, setShowedMore] = useState(false);

  const consumerValue = consumers.find((value) => value.value === get(variables, 'consumerId'))?.value as string;
  const credentialValue = credentials.find((value) => value.value === get(variables, 'apiKey'))?.value as string;

  const moreVariables = Object.keys(variables)
    .filter((key) => !filteredVars.includes(key))
    .sort();

  return (
    <Card>
      <TitleWrapper>
        <Title level={5} mb={8} weight={400}>
          Global variables
        </Title>
      </TitleWrapper>
      <Form autoComplete='off' layout='vertical' name='webhook'>
        <Form.Item label='API key'>
          <FormItemWrapper>
            <Input
              placeholder='Enter API key'
              value={get(variables, 'apiKey')}
              onChange={handleSetVariables('apiKey')}
            />
            {credentials.length > 0 && (
              <ExplorerSelect
                options={credentials}
                placeholder='Select API key'
                value={credentialValue}
                onChange={(value) => handleSearchVariables('apiKey')(value as string)}
                onSearch={handleSearchVariables('apiKey')}
              />
            )}
          </FormItemWrapper>
        </Form.Item>
        <Form.Item label='Consumer ID'>
          <FormItemWrapper>
            <Input
              placeholder='Enter consumer Consumer ID'
              value={get(variables, 'consumerId')}
              onChange={handleSetVariables('consumerId')}
            />
            {consumers.length > 0 && (
              <ExplorerSelect
                options={consumers}
                placeholder='Select consumer Consumer ID'
                value={consumerValue}
                onChange={(value) => handleSearchVariables('consumerId')(value as string)}
              />
            )}
          </FormItemWrapper>
        </Form.Item>
        {isShowedMore &&
          moreVariables.map((key) => (
            <Form.Item key={key} label={key}>
              <Input
                placeholder={`Enter consumer ${key}`}
                value={get(variables, key)}
                onChange={handleSetVariables(key)}
              />
            </Form.Item>
          ))}
      </Form>
      <Button type={ButtonTypeEnum.Link} onClick={() => setShowedMore((prev) => !prev)}>
        {isShowedMore ? 'Show less' : 'Show more'}
      </Button>
    </Card>
  );
};
